import React from 'react'
import { Link } from 'react-router-dom'
import { Close } from '@mui/icons-material'
import { Box, List, ListItem, ListItemText } from '@mui/material'
import PropTypes from 'prop-types'

import useOrbitFlag from '../../../../hooks/useOrbitFlag'
import { CLIENT_NAVLINKS, VENDOR_NAVLINKS } from '../navlinks'
function MobileMenu({ role, toggleDrawer }) {
  const renderLink = (link) => {
    return (
      useOrbitFlag(link.flag) && (
        <ListItem
          key={link.title}
          button
          component={Link}
          to={link.to}
          onClick={() => toggleDrawer(false)}
        >
          <ListItemText
            primary={link.title}
            primaryTypographyProps={{ fontSize: '2em' }}
          />
        </ListItem>
      )
    )
  }

  return (
    <Box
      display='flex'
      role='presentation'
      flexDirection='row'
      justifyContent='space-between'
      marginX='20px'
    >
      <Box>
        <List
          sx={{
            marginY: '10px'
          }}
        >
          {['owner', 'admin'].includes(role) && CLIENT_NAVLINKS.map(renderLink)}
          {['opsowner', 'ops'].includes(role) &&
            VENDOR_NAVLINKS.map(renderLink)}
        </List>
      </Box>
      <Box marginY='2em'>
        <Close fontSize='medium' onClick={() => toggleDrawer(false)} />
      </Box>
    </Box>
  )
}

MobileMenu.propTypes = {
  role: PropTypes.string,
  toggleDrawer: PropTypes.func
}

export default MobileMenu
